import { render, staticRenderFns } from "./PlanPolygonViewer.vue?vue&type=template&id=c90f9b2a"
import script from "./PlanPolygonViewer.vue?vue&type=script&lang=js"
export * from "./PlanPolygonViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports